import { Role } from '@caresend/types';
import { asyncTimeout } from '@caresend/utils';
import cloneDeep from 'lodash.clonedeep';
import debounce from 'lodash.debounce';
import isEqual from 'lodash.isequal';
import { defineComponent, ref, computed, watch, onUnmounted } from 'vue';
import __vue_component__$1 from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../../../../../cards/BasicCard/BasicCard.vue.js';
import __vue_component__$3 from '../../../ItineraryWaypoint/ItineraryWaypointCard.vue.js';
import { useItineraryGeoSearch } from '../../../useItineraryGeoSearch.js';
import { usePortalStore } from '../../../../store/portal/index.js';
import __vue_component__$5 from '../../../../../../transitions/TransitionDownUp/TransitionDownUp.vue.js';
import __vue_component__$6 from '../../../../../../transitions/TransitionFadeOutIn/TransitionFadeOutIn.vue.js';
import __vue_component__$2 from '../../../../../../ui/ColorCircle.vue.js';
import __vue_component__$4 from '../../../../../../ui/Map/MapView.vue.js';
import { useMediaQuery, useElementDimensions, debouncedComputed, delayedComputed } from '../../../../../../../composables/dom.js';
import { getStore } from '../../../../../../../store/helpers/initStore.js';
import { getRoute } from '../../../../../../../router/helpers/initRouter.js';
import 'immutability-helper';
import '../../../../../../../router/routes/dev/model.js';
import '../../../../../../../router/routes/dev/routes.js';
import '../../../../../../../router/routes/dashboard/model.js';
import '../../../../../../../router/routes/pro/model.js';
import '../../../../../../../router/routes/visitsPage/model.js';
import '../../../../../../../router/routes/orderFlow/model.js';
import '../../../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../../../router/routes/orderFlow/routes.js';
import '../../../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../../../router/routes/chartingFlow/model.js';
import '../../../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../../../router/routes/portal/portalRoutes.js';
import '../../../../../../../router/routes/portal/model.js';
import '../../../../../../../router/routes/visitsPage/routes.js';
import '../../../../store/portal/sessionStore.js';
import 'file-saver';
import '../../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../../database/encryption/model.js';
import 'js-sha256';
import '../../../../store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../../../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../../../../../database/firebaseConfig/init.js';
import '../../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../../ui/Icon.vue.js';
import '../../../../../../../functions/configuration/icons.js';
import '../../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../../functions/tracking/index.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import '../../../../../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../../../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../../../../../store/pinia/draftWaypoints/index.js';
import '../../../../../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../../../../../store/modules/chartingFlow/model.js';
import '../../../../../../../store/modules/office/index.js';
import '../../../../../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../../../../../store/modules/office/model.js';
import '../../../../../../../store/modules/orderFlow/index.js';
import '../../../../../../../store/modules/procedures/model.js';
import '../../../../../../../store/modules/schedulingFlow/index.js';
import '../../../../../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'PortalMap',
    components: {
        BasicCard: __vue_component__,
        ButtonComponent: __vue_component__$1,
        ColorCircle: __vue_component__$2,
        ItineraryWaypointCard: __vue_component__$3,
        MapView: __vue_component__$4,
        TransitionDownUp: __vue_component__$5,
        TransitionFadeOutIn: __vue_component__$6,
    },
    props: {
        colorScheme: {
            type: String,
            default: 'light',
        },
        legend: {
            type: Array,
            default: null,
        },
        loadingMessage: {
            type: String,
            default: null,
        },
        displaySearchButton: {
            type: Boolean,
            default: true,
        },
        mapFocused: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const coords = ref();
        const userMovedMap = ref(false);
        const geoSearch = useItineraryGeoSearch();
        const portalStore = usePortalStore();
        const { viewAs } = portalStore;
        const { matches: isMobile } = useMediaQuery('mobile');
        const nextInTransitWaypoint = computed(() => portalStore.itinerary.getters.nextInTransitWaypoint());
        const isTransitMode = computed(() => !!nextInTransitWaypoint.value && isMobile.value && viewAs.nurse);
        const mapHighlightID = computed(() => geoSearch.mapHighlightID);
        const mapSources = computed(() => {
            const sources = geoSearch.mapSources;
            if (isTransitMode.value) {
                return sources.filter((source) => { var _a; return source.id === ((_a = nextInTransitWaypoint.value) === null || _a === void 0 ? void 0 : _a.id); });
            }
            return sources;
        });
        const searchBlocked = computed(() => geoSearch.searchBlocked);
        watch(userMovedMap, () => {
            if (userMovedMap.value) {
                emit('promptSearch', coords.value);
            }
        });
        const setIsUserInitiated = () => {
            userMovedMap.value = true;
        };
        const emitNewBounds = (isUserInitiated) => {
            const userInitiated = isUserInitiated !== null && isUserInitiated !== void 0 ? isUserInitiated : userMovedMap.value;
            // Reset the userMovedMap flag
            userMovedMap.value = false;
            if (!coords.value)
                return;
            emit('newBounds', {
                coords: coords.value,
                userInitiated,
            });
        };
        const getIsMapIdle = async () => {
            const dupe = cloneDeep(coords.value);
            await asyncTimeout(100);
            return isEqual(dupe, coords.value);
        };
        const onMapLoad = async () => {
            /** Determine if the map is in an idle state */
            const isIdle = await getIsMapIdle();
            if (isIdle)
                emitNewBounds();
        };
        const setNewBounds = (newBounds) => {
            coords.value = newBounds !== null && newBounds !== void 0 ? newBounds : undefined;
        };
        const mapCallbacks = {
            dragend: () => setIsUserInitiated(),
            load: () => onMapLoad(),
            wheel: () => setIsUserInitiated(),
        };
        const mapContainer = ref(null);
        const buttonContainer = ref(null);
        const { width } = useElementDimensions(mapContainer, {
            resize: true,
        });
        const { height: buttonContainerHeight } = useElementDimensions(buttonContainer);
        const mobilePadding = computed(() => {
            var _a;
            const padding = 30;
            const controlPanelCompensation = isTransitMode.value ? 140 : 0;
            const buttonTop = ((_a = buttonContainerHeight.value) !== null && _a !== void 0 ? _a : 0) + controlPanelCompensation;
            const bottom = buttonTop + padding;
            const legendCompensation = !isTransitMode.value ? 110 : 30;
            const top = legendCompensation + padding;
            return {
                /** Compensate for drawer-like interaction with waypoint list */
                bottom: Math.round(bottom),
                top: Math.round(top),
                left: Math.round(padding),
                right: Math.round(padding),
            };
        });
        const customPadding = computed(() => {
            var _a, _b;
            return isMobile.value ? mobilePadding.value : {
                bottom: 140,
                top: 240,
                /** Compensate for waypoint-list when statically positioned */
                left: (((_b = (width.value || ((_a = mapContainer.value) === null || _a === void 0 ? void 0 : _a.clientWidth))) !== null && _b !== void 0 ? _b : 0) * 0.55) + 80,
                right: 80,
            };
        });
        const onMapLoading = (loading) => {
            emit('mapLoading', loading);
        };
        const store = getStore();
        const currentRoute = getRoute();
        const displayLegend = computed(() => {
            var _a, _b, _c;
            return ((_b = (_a = currentRoute.value.meta) === null || _a === void 0 ? void 0 : _a.portal) === null || _b === void 0 ? void 0 : _b.displayLegend)
                && !(viewAs.nurse || ((_c = store.state.auth.user) === null || _c === void 0 ? void 0 : _c.role) === Role.NURSE);
        });
        const willDisplayMapTooltip = debouncedComputed(() => props.mapFocused
            && isMobile.value
            && !displayLegend.value
            && !mapSources.value.length, 1000);
        /** Use a second value to ensure the transition is triggered */
        const displayMapTooltip = delayedComputed(() => willDisplayMapTooltip.value, 1000);
        const mapCopyDC = computed(() => { var _a, _b, _c; return (_c = (_b = (_a = store.state.variables.variables) === null || _a === void 0 ? void 0 : _a.dynamicCopy) === null || _b === void 0 ? void 0 : _b.nurseApp) === null || _c === void 0 ? void 0 : _c.mapTooltip; });
        const debouncedEmitNewBounds = debounce(() => {
            emitNewBounds();
        }, 250);
        watch(coords, () => {
            debouncedEmitNewBounds();
        });
        onUnmounted(() => {
            debouncedEmitNewBounds.cancel();
        });
        return {
            buttonContainer,
            customPadding,
            displayLegend,
            emitNewBounds,
            isMobile,
            isTransitMode,
            nextInTransitWaypoint,
            mapCallbacks,
            mapContainer,
            mapCopyDC,
            mapHighlightID,
            mapSources,
            onMapLoading,
            searchBlocked,
            setIsUserInitiated,
            setNewBounds,
            willDisplayMapTooltip,
            displayMapTooltip,
            userMovedMap,
            viewAs,
        };
    },
});

export { script as default };
